import {
  BlockStack,
  Card,
  InlineGrid,
  Text,
  Badge,
  Spinner,
} from "@shopify/polaris";
import { React, useEffect, useState } from "react";
import supabase from "../../../supabase-client";
import { useNavigate } from "react-router-dom";

function ServicesBar() {
  const navigate = useNavigate();
  const [pendingOdoAdjustments, setPendingOdoAdjustments] = useState(undefined);
  const [serviceStatus, setServiceStatus] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const { count } = await supabase
        .from("car_odometer_submissions")
        .select("", { count: "exact" })
        .eq("status", "pending");
      setPendingOdoAdjustments(count);

      const { data, error } = await supabase.rpc(
        "get_upcoming_services_reduced"
      );

      if (error) {
        console.error(error);
        return;
      }

      // Initialize counters
      const counters = {
        critical: 0,
        attention: 0,
        upcoming: 0,
        far: 0,
      };

      data.forEach((item) => {
        const { kms_remaining, service_type_ids } = item;

        const isOil = service_type_ids.includes(1); // service type 1 = Cambio de Aceite

        if (kms_remaining < 0 && isOil) counters.critical++;
        else if (kms_remaining < 0) counters.attention++;
        else if (kms_remaining <= 500) counters.upcoming++;
        else counters.far++;
      });

      setServiceStatus(counters);
    };

    fetchData();
  }, []);

  const servicesStatusBar = () => {
    if (!serviceStatus) {
      return (
        <Card>
          <BlockStack gap={200}>
            <Text variant="headingSm">Servicios</Text>
            <Spinner size="small" />
          </BlockStack>
        </Card>
      );
    }

    const { critical, attention, upcoming, far } = serviceStatus;

    return (
      <Card>
        <BlockStack gap={200}>
          <Text variant="headingSm">Servicios Pendientes</Text>

          <InlineGrid columns={4} gap={200}>
            {/* CRÍTICOS (aceite vencido) */}
            <BlockStack gap={100}>
              <Text tone="subdued" variant="bodySm">
                Críticos
              </Text>
              {critical > 0 ? (
                <div
                  onClick={() => navigate("/services_dashboard")}
                  style={{ cursor: "pointer", display: "grid" }}
                >
                  <Badge tone="critical-strong">{critical}</Badge>
                </div>
              ) : (
                <Badge tone="subdued">{critical}</Badge>
              )}
            </BlockStack>

            {/* ATENCIÓN (otros servicios vencidos) */}
            <BlockStack gap={100}>
              <Text tone="subdued" variant="bodySm">
                Requeridos
              </Text>
              {attention > 0 ? (
                <div
                  onClick={() => navigate("/services_dashboard")}
                  style={{ cursor: "pointer", display: "grid" }}
                >
                  <Badge tone="warning">{attention}</Badge>
                </div>
              ) : (
                <Badge tone="subdued">{attention}</Badge>
              )}
            </BlockStack>

            {/* PRÓXIMOS */}
            <BlockStack gap={100}>
              <Text tone="subdued" variant="bodySm">
                Por Vencer
              </Text>
              {upcoming > 0 ? (
                <div
                  onClick={() => navigate("/services_dashboard")}
                  style={{ cursor: "pointer", display: "grid" }}
                >
                  <Badge tone="attention">{upcoming}</Badge>
                </div>
              ) : (
                <Badge tone="subdued">{upcoming}</Badge>
              )}
            </BlockStack>

            {/* LEJANOS */}
            <BlockStack gap={100}>
              <Text tone="subdued" variant="bodySm">
                Por Programar
              </Text>
              {far > 0 ? (
                <div
                  onClick={() => navigate("/services_dashboard")}
                  style={{ cursor: "pointer", display: "grid" }}
                >
                  <Badge tone="success">{far}</Badge>
                </div>
              ) : (
                <Badge tone="subdued">{far}</Badge>
              )}
            </BlockStack>
          </InlineGrid>
        </BlockStack>
      </Card>
    );
  };

  const gpsAdjustmentsBar = () => {
    const isReady = pendingOdoAdjustments !== undefined;
    return (
      <Card>
        <BlockStack gap={200}>
          <Text variant="headingSm">Odometros</Text>
          {!isReady ? (
            <Spinner size="small" />
          ) : (
            <InlineGrid columns={2}>
              <BlockStack>
                <Text tone="subdued" variant="bodySm">
                  Ajustes Pendientes
                </Text>
                <div
                  style={{
                    display: "grid",
                    cursor: pendingOdoAdjustments ? "pointer" : "default",
                  }}
                  onClick={() => {
                    if (!pendingOdoAdjustments) return;
                    navigate("/odometer_requests");
                  }}
                >
                  <Badge
                    tone={pendingOdoAdjustments > 0 ? "attention" : undefined}
                  >
                    {(pendingOdoAdjustments ?? 0).toString()}
                  </Badge>
                </div>
              </BlockStack>
            </InlineGrid>
          )}
        </BlockStack>
      </Card>
    );
  };

  return (
    <BlockStack gap={200}>
      <Text variant="headingMd">Servicios</Text>
      <InlineGrid
        gap={200}
        columns={["twoThirds", "oneThird"]}
        height={"300px"}
      >
        {servicesStatusBar()}
        {gpsAdjustmentsBar()}
      </InlineGrid>
    </BlockStack>
  );
}

export default ServicesBar;
